import React, { useCallback, useEffect, useState } from 'react';
import "./Flowchart.scss"

import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import CustomNode from '../../components/Nodes/CustomNode';

import ModalEmpleadoConsul from '../../components/Modales/Flowchart/ModalEmpleadoConsul';

import { jwtDecode } from "jwt-decode"
import { useAdmin } from '../../context/AdminContext';

const nodeTypes = {
  custom: CustomNode
};

export const flowchartEmpresasContext = React.createContext()

const spacingX = 170

function FlowchartEmpresas() {
  const auth = localStorage.getItem("token")
  const jwtParse = jwtDecode(auth)
  const USER = jwtParse.apirest.objeto

  const { empresas, fetchEmpresasById } = useAdmin()

  const [modalEmpleado, setModalEmpleado] = useState(false)
  const [idEmpresaFlow, setIdEmpresaFlow] = useState(null)

  const [nodes, setNodes, onNodesChange] = useNodesState([])
  const [edges, setEdges, onEdgesChange] = useEdgesState([])

  useEffect(()=>{
    fetchEmpresasById(USER, USER.idConsultora)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(()=>{
    totalNodes()
    totalEdges()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresas])

  const fetchEmpleadosById = async (user, idEmpresa) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/viewUserCompany`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            user: user,
            idEmpresa: parseInt(idEmpresa)
        })
    })
    const data = await res.json()
    return data
  }

  // const objConsultora = consultoras.find((e)=>e.id_consultora === USER.idConsultora)

  const handleModalEmpleado = (id) => {
    setIdEmpresaFlow(parseInt(id))
    setModalEmpleado(true)
  }

  const totalNodes = async () => {

    const empresasNodes = empresas.map((empresa, i) => {
      return {
        id: `empresa-${empresa.id_empresa}`,
        position: { x: i * spacingX, y: 50 },
        data: { label: empresa.nombre },
        parentNode: 'parent',
        extent: 'parent',
        style: {
          backgroundColor: '#e6efff'
        }
      }
    })

    const offsetX = (empresasNodes.length - 1) * spacingX;

    const parentNode = {
      id: 'parent',
      position: { x: offsetX / 2, y: 0 },
      // data: { label: `${objConsultora.nombre}` },
      data: { label: "Consultora" },
      style: {
        backgroundColor: '#9ec5fe'
      }
    }

    const empleadosNodesPerEmpresa = await Promise.all(
      empresas.map(async (empresa, empresaIndex) => {
        const empleados = await fetchEmpleadosById(USER, empresa.id_empresa)
        const empresaX = empresaIndex * spacingX

        const empleadosNodes = empleados.objeto.map((empleado, empleadoIndex) => ({
          id: `empleado-${empresa.id_empresa}-${empleado.id_empleado}`,
          position: { x: empresaX, y: 100 + empleadoIndex * 80 },
          data: { label: empleado.nombre },
          parentNode: `empresa-${empresa.id_empresa}`,
          extent: 'parent',
          style: {
            backgroundColor: '#f8f9fa'
          }
        }))

        const lastY = 
          empleadosNodes.length > 0
          ? empleadosNodes[empleadosNodes.length - 1].position.y + 50
          : 100;

        const customNodeBtn = {
          id: `add-btn-${empresa.id_empresa}`,
          type: 'custom',
          position: {
            x: empresaX,
            y: lastY
          },
          data: {
            label: '+ Agregar',
            onClick: () => handleModalEmpleado(empresa.id_empresa)
          },
          parentNode: `empresa-${empresa.id_empresa}`,
          extent: 'parent'
        }

        return [...empleadosNodes, customNodeBtn]
        
      })
    )

    const empleadosNodes = empleadosNodesPerEmpresa.flat()
    
    const allNodes = [parentNode, ...empresasNodes, ...empleadosNodes]
    setNodes(allNodes)
  }

  const totalEdges = async () => {
    const empresaEdges = empresas.map((empresa) => ({
      id: `edge-parent-empresa-${empresa.id_empresa}`,
      source: 'parent',
      target: `empresa-${empresa.id_empresa}`,
      // type: 'smoothstep',
    }));

    const empleadosEdgesPerEmpresa = await Promise.all(
      empresas.map(async (empresa) => {
        const empleados = await fetchEmpleadosById(USER, empresa.id_empresa);

        return empleados.objeto.map((empleado) => ({
          id: `edge-empresa-${empresa.id_empresa}-empleado-${empleado.id_empleado}`,
          source: `empresa-${empresa.id_empresa}`,
          target: `empleado-${empresa.id_empresa}-${empleado.id_empleado}`,
          // type: 'smoothstep',
        }));
      })
    );

    const botonEdges = empresas.map((empresa) => ({
      id: `edge-empresa-${empresa.id_empresa}-addbtn`,
      source: `empresa-${empresa.id_empresa}`,
      target: `add-btn-${empresa.id_empresa}`,
    }));

    const empleadosEdges = empleadosEdgesPerEmpresa.flat();

    setEdges([...empresaEdges, ...empleadosEdges, ...botonEdges]);
  }

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges],
  );

  return (
    <>
      <flowchartEmpresasContext.Provider value={{ idEmpresaFlow, fetchEmpleadosById, totalNodes }}>
        <ModalEmpleadoConsul show={modalEmpleado} onHide={()=>setModalEmpleado(false)}/>
        <div className='section__header d-flex flex-row align-items-end mb-4'>
          <i className='bi bi-people-fill me-2'></i>
          <h4 className='m-0'>Admin</h4>
        </div>
        {/* Flowchart */}
        <div className='flow border border-1'>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            nodeTypes={nodeTypes}
            onConnect={onConnect}
            onInit={(instance) => {
              instance.fitView({ minZoom: 0.7, maxZoom: 1 });
            }}
          >
            <Controls />
            <MiniMap />
            <Background variant="dots" gap={12} size={1} />
          </ReactFlow>
        </div>
      </flowchartEmpresasContext.Provider>
    </>
  )
}

export default FlowchartEmpresas